


import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";

import { Header } from '../../Components/Layout/Header.jsx'
import { AccountTabletLinkovi } from '../../Components/Account/AccountTabletLinkovi.jsx'
import { RestrictedAccess } from '../../Components/Layout/RestrictedAccess.jsx'


import { CasinoLink } from '../../Components/Layout/CasinoLink.jsx'
import { Wallet2 } from '../../Components/Account/Wallet2.jsx'
import { AccountLinkovi } from '../../Components/Account/AccountLinkovi.jsx'

export  class AccountGameProviderDetails extends React.Component {

    constructor(props) {
        super(props);

        // this.fetchMore = this.fetchMore.bind(this);
        this.state = {};

        // this.getDetails = this.getDetails.bind(this);
        // this.setDetails = this.setDetails.bind(this);

        // this.getDetails();
    }



    getDetails() {
        this.props.showLoadingFn(true);
        var promises = Promise.all([casino.repos.playerGameDetailsRepo.get(this.props.route.match.params.providerId, this.props.route.match.params.gameId, 1)]);
        this.dataPromises = casino.utils.makeCancelablePromise(promises);
        this.dataPromises.promise.then(this.setDetails, function (reason) { });
    }

    setDetails(data) {
        this.setState({ info: data[0], data: data[0].items, hasMore: data[0].hasMore, working: false })
        this.props.showLoadingFn(false);
    }


    componentWillUnmount() {
        // this.props.showLoadingFn(false);

    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }


    // fetchMore() {
    //     var that = this;
    //     this.props.showLoadingFn(true);
    //     var page = (this.state.page + 1)
    //     this.setState({ working: true });

    //     casino.repos.playerGameDetailsRepo.get(this.props.route.match.params.providerId, this.props.route.match.params.gameId, page).then(function (data) {
    //         that.setState({ info: data, data: that.state.data.concat(data.items), working: false, hasMore: data.hasMore, page: page })
    //         that.props.showLoadingFn(false);
    //     });
    // }


    // renderTran(x) {

    //     var providerId = this.props.route.match.params.providerId;
    //     var gameId = this.props.route.match.params.gameId;

    //     return <tr key={x.id} className="horizontal-lines">
    //         <td><span className="text" >{x.game}</span></td>
    //         <td><span className="text-left">{casino.utils.dateToDateString(new Date(x.datum))} {casino.utils.dateToTimeString(new Date(x.datum))}</span></td>
    //         <td className="text-right text-bold"><span>{casino.utils.numberToKune(x.bet)}</span></td>
    //         <td className="text-right text-bold"><span style={{ lineHeight: "35px" }}>{casino.utils.numberToKune(x.win)}</span></td>

    //         <td className="text-center">
    //             <ReactRouterDOM.NavLink style={{'color' : '#333', fontSize: '16px'}} onClick={() => casino.states["games-details"] = this.state} to={this.props.getHomePathFn(this.props.route.location, '/account/games/' + providerId + '/' + gameId + '/details')}>
    //                 &nbsp; <span className="icon ico-info "></span> 
    //             </ReactRouterDOM.NavLink>
    //         </td>
    //     </tr>
    // }



    render() {

        var pathName = this.props.route.match.url;
        var user = this.props.user;

        var providerId = this.props.route.match.params.providerId;
        var gameId = this.props.route.match.params.gameId;
        var roundId = this.props.route.match.params.roundId;


        if (this.props.user) {
            return <div>


                {!this.redirectDone && this.state.redirectTo && <Redirect to={{ pathname: this.state.redirectTo, state: this.state.redirectToState }} />}
                {this.redirectDone = true}

                <Route exact path={pathName} render={(route) =>
                    (<Header key="header" {...this.state} nativeAppVisible={true} {...this.props} detailsHeader="true" headerText={"Detalji"} headerBackUrl={this.props.getHomePathFn(this.props.route.location, '/account/games/' + providerId + '/' + gameId)}></Header>)} />

                <div className="flex margin-1p-on-tablet">
                    <AccountTabletLinkovi {...this.props} ></AccountTabletLinkovi>

                    <div id="page-wrapper" className="white flex-expand-1 border-on-tablet no-padding" style={{ minHeight: '400px' }}>



                        <div className="header-2">
                            <h1 className="text">Detalji vrtnje</h1>
                        </div>
                        <div className="clearfix flex-equal-size maximum">
                            <div className="" style={{ minHeight: '600px' }}>

                                {
                                    <div className="padding-sides-medium margin-top text-center">
                                        <span style={{ fontStyle: 'italic', fontSize: '12px' }}>
                                            *detalje možete ispisati na vašem računalu</span>
                                    </div>
                                }
                                <br></br>
                                <div className="padding-sides-medium ">
                                    <iframe 
                                        onLoad={() => document.getElementById("detaljiFrame").style.height = (document.getElementById("detaljiFrame").contentWindow.document.body.scrollHeight + 200) + 'px'} 
                                        id="detaljiFrame" 
                                        style={{ width: '100%', minHeight: '400px' }} frameBorder="0" 
                                        src={casino.config.urls.web + 'profil/detaljiigre/' + roundId + "?forMobile=1&fd=1"} >
                                    </iframe>
                                </div>
                                <br></br>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        } else {
            return <div>
                <Header key="header" {...this.state} {...this.props}></Header>
                <RestrictedAccess {...this.props} />


                {!this.redirectDone && this.state.redirectTo && <Redirect to={{ pathname: this.state.redirectTo, state: this.state.redirectToState }} />}
                {this.redirectDone = true}


            </div>

        }
    }
};
